import { takeEvery } from 'redux-saga/effects';

import { ActionTypes } from '../constants';
import { refreshProject } from './refreshProject';

export default [
  takeEvery(ActionTypes.REFRESH_PROJECT, refreshProject),
];
